<!-- /src/components/common/Pagination.vue -->
<template>
  <ul class="pagination" v-if="total > 1">
    <router-link
      class="pagination__item pagination__item--prev"
      v-if="currentPage > 1"
      :to="mkRouteObj(--currentPage)"
    >
      <i class="fal fa-chevron-left"></i>
    </router-link>
    <router-link
      v-for="(p, i) in pagination"
      :key="i"
      :class="[
        'pagination__item',
        'pagination__item--' + p.type,
        {
          'pagination__item--current': p.val == currentPage,
        },
      ]"
      :to="p.route"
      >{{ p.val }}</router-link
    >

    <router-link
      class="pagination__item pagination__item--next"
      v-if="currentPage !== totalPages"
      :to="mkRouteObj(++currentPage)"
    >
      <i class="fal fa-chevron-right"></i>
    </router-link>
  </ul>
</template>

<script>
import defaults from 'lodash/defaults'

export default {
  props: ['page', 'total'],
  computed: {
    totalPages() {
      return Math.ceil(this.total)
    },
    
    currentPage: {
      get() {
        return parseInt(this.page)
      },
      set(value) {
        return value
      },
    },

    pagination() {
      let pagination = []

      if (this.totalPages <= 10) {
        for (let i = 1; i <= this.totalPages; i++) {
          pagination.push({
            type: 'page',
            val: i,
            route: this.mkRouteObj(i),
          })
        }
      } else {
        let start = Math.max(this.currentPage - 3, 1)
        let end = Math.min(this.currentPage + 3, this.totalPages)

        if (this.currentPage < 4) {
          start = 1
          end = 7
        }

        if (this.currentPage + 3 >= this.totalPages) {
          start = this.totalPages - 6
        }

        for (let i = start; i <= end; i++) {
          pagination.push({
            type: 'page',
            val: i,
            route: this.mkRouteObj(i),
          })
        }
      }
      return pagination
    },
  },
  methods: {
    mkRouteObj(page) {
      const { name } = this.$route
      const query = Object.assign({}, this.$route.query)
      // const hash = '#page-header'
      query['page'] = page
      return {
        name,
        query,
        // hash,
      }
    },
  },
}
</script>

<style scoped>
.pagination {
  display: flex;
  flex-wrap: wrap;
  align-content: center;
  justify-content: center;
  line-height: 1;
  width: 100%;

  @media (--tablet) {
    align-content: flex-end;
    justify-content: flex-end;
  }

  &__item {
    padding: 0 0.25rem;
    text-align: center;
    border-radius: 50%;
    color: var(--darkGray);
    width: 40px;
    height: 40px;
    background-color: white;
    margin-right: 0.25rem;

    &:last-child {
      margin-right: 0;
    }

    &--prev,
    &--next {
      position: relative;

      i {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }

    &--page {
      cursor: pointer;
      padding-top: 0.5rem;
      padding-bottom: 0.5rem;
    }

    &--gap {
      transform: translateY(-6px);
    }

    &--current {
      background-color: var(--brandPrimary);
      color: white;
      font-weight: var(--fontWeightSemibold);
      /* font-size: 1.3rem; */
    }
  }
}
</style>
